import { ConfirmationDialog } from "../../../../assets/types";
import { FormatHelper } from "../../../../assets/utils/helpers";
import { Constants } from "../../../../assets/utils/lib/constants";
import { LoadingIndicator } from "../../../../assets/vfx";
import { VfxDialogProps } from "../../../../assets/vfx/dialog/vfxDialogProps";
import Drawer from "../../../../assets/vfx/drawer/drawer";
import { CommunityCategoryDto } from "../../../../services/dto";
import DisplayData from "../../../common/DisplayData/DisplayData";
import { CategoryLookupProps } from "./categoryForm";

interface CategoryViewProps {
  data?: CommunityCategoryDto;
  show: boolean;
  lookups?: CategoryLookupProps;
  onHide: () => void;
  onEdit: () => void;
  onCancel: () => void;
  onDelete: () => void;
}

export const CategoryView = (props: CategoryViewProps) => {
  const community: string | undefined = props.lookups?.communities.find(
    (x) => x.value === props.data?.communityId
  )?.display;

  const modalDialogProps: VfxDialogProps | undefined =
    new ConfirmationDialog().get(props.onDelete, "Delete", {
      Name: props.data?.name ?? Constants.emptyString,
    });

  return (
    <Drawer.View
      className="w-30"
      show={props.show}
      backdrop={true}
      placement="end"
      scroll={true}
      title={"View Category"}
      modalDialogProps={modalDialogProps}
      onHide={props.onHide}
      onEdit={props.onEdit}
      onDelete={props.onDelete}
    >
      {!props.data ? (
        <LoadingIndicator isFullPage />
      ) : (
        <>
          <DisplayData text="Name" importedData={props.data?.name} />

          <DisplayData
            text="Description"
            importedData={props.data?.description}
          />
          <DisplayData text="Community" importedData={community} />

          <DisplayData
            text="activation Date"
            importedData={
              props.data?.activationDate
                ? FormatHelper.formatDate(props.data?.activationDate)
                : Constants.emptyString
            }
          />
        </>
      )}
    </Drawer.View>
  );
};
